import { render, staticRenderFns } from "./chateau-langoa-barton.vue?vue&type=template&id=fe4a4d2e&scoped=true"
import script from "./chateau-langoa-barton.vue?vue&type=script&lang=js"
export * from "./chateau-langoa-barton.vue?vue&type=script&lang=js"
import style0 from "./chateau-langoa-barton.vue?vue&type=style&index=0&id=fe4a4d2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe4a4d2e",
  null
  
)

export default component.exports